import React from 'react';
import { Outlet } from 'react-router-dom';

const Landing: React.FC = () => {
  return (
    <React.Fragment>
      <Outlet />
    </React.Fragment>
  );
};

export default Landing;
